
import React, { useState } from "react";
import styles from "./PhotoGallery.module.css";

const PhotoGallery: React.FC = () => {
  const [photos, setPhotos] = useState<string[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          setPhotos((prevPhotos) => [...prevPhotos, reader.result as string]);
        }
      };
      reader.readAsDataURL(selectedFile);
      setSelectedFile(null); // Clear the selected file
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Photo Gallery</h1>
      <div className={styles.uploadSection}>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className={styles.fileInput}
        />
        <button
          onClick={handleUpload}
          className={styles.uploadButton}
          disabled={!selectedFile}
        >
          Upload Photo
        </button>
      </div>
      <div className={styles.gallery}>
        {photos.map((photo, index) => (
          <div key={index} className={styles.photoCard}>
            <img src={photo} alt={`Uploaded ${index}`} className={styles.photo} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;
